class ProductSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Close dropdown when clicking outside but within the component
    this.addEventListener('click', () => {
      this.querySelector('.product-switcher-dropdown').classList.toggle(
        'is-closed'
      );
      const button = this.querySelector('.product-switcher-button');
      button.classList.toggle('rounded-b-full');
      button.classList.toggle('rounded-t-full');
    });
  }
}

// Register the web component
customElements.define('product-switcher', ProductSwitcher);
